import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip, P } from '@PipelineDeals/shared-react-components'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  align-items:  ${props => props.centered ? 'center' : 'inherit'}
  justify-content: ${props => props.centered ? 'center' : 'inherit'};
  gap: 6px;
`
const Dot = styled.div`
  display: inline-block;
  height: 12px;
  width: 12px;
  border-radius: 3ex;
  background-color: #${props => props.color};
  align-self: center;
`

const LeadStatusFormated = ({ name, color, hideName, centered }) => {
  return (
    <Wrapper centered={centered}>
      {hideName &&
        <Tooltip content={name}>
          <Dot color={color} />
        </Tooltip>}

      {!hideName && <Dot color={color} />}
      {!hideName && <P> {name}</P>}
    </Wrapper>
  )
}

LeadStatusFormated.propTypes = {
  name: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  hideName: PropTypes.bool,
  centered: PropTypes.bool
}

export default LeadStatusFormated
